var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multimedia"},[_c('AppleTvVideo',{attrs:{"video-name":require('@/assets/videos/multimedia.mp4')}}),_c('div',{staticClass:"texts"},[_c('h3',[_vm._v(_vm._s(_vm.$t("pages.multimedia.subtitle1")))]),_c('p',[_vm._v(_vm._s(_vm.$t("pages.multimedia.text1")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }